import React from "react";
import DiaryBoard from "../../components/diary/DiaryBoard";
import { Navigate, Route, Routes } from "react-router-dom";
import AdminMontessoriMenu from "./AdminMontessoriMenu";
import Index from "./pages/Index";
import AdminSwitchMontessoriCard from "./pages/Is-kool-Junior/montessori-progress-card/AdminSwitchMontessoriCard";
import AdminMontessoriViewTemplate from "./pages/Is-kool-Junior/montessori-progress-card/AdminMontessoriViewTemplate";
import AdminMontessoriAddEditScore from "./pages/Is-kool-Junior/montessori-progress-card/AdminMontessoriAddEditScore";
import AdminMontessoriViewEditCard from "./pages/Is-kool-Junior/montessori-progress-card/AdminMontessoriViewEditCard";
import AdminMontessoriViewHistory from "./pages/Is-kool-Junior/montessori-progress-card/AdminMontessoriViewHistory";

import AdmissionProfile from "./pages/Is-kool-Junior/admission/AdmissionProfile";
import SwitchAdmission from "./pages/Is-kool-Junior/admission/SwitchAdmission";
import ViewAdmission from "./pages/Is-kool-Junior/admission/ViewOnlyPage";

import InstructorPage from "./pages/Is-kool-Junior/instructor/InstructorPage";
import SupportStaffPage from "./pages/components/supportstaff/SupportStaffPage";
import SwitchInstructor from "./pages/Is-kool-Junior/instructor/SwitchInstructor";
import SwitchMontessoriAttendance from "./pages/Is-kool-Junior/montessori-attendance/SwitchMontessoriAttendance";

import ManageStudentMain from "./pages/Is-kool-Junior/student/ManageStudentMain";
import SwitchStudent from "./pages/Is-kool-Junior/student/SwitchStudent";

import ClassMain from "./pages/Is-kool-Junior/classes/ClassMain";
import SwitchClass from "./pages/Is-kool-Junior/classes/SwitchClass";

import HomeWork from "./pages/Is-kool-Junior/homework/HomeWork";

import AdminCourseBoardMain from "./pages/Is-kool-Junior/course-board/AdminCourseBoardMain";
import AdminCourseBoardView from "./pages/Is-kool-Junior/course-board/AdminCourseBoardView";

import AddEditFeeTemplate from "./pages/components/managefee/AddEditTemplate";
import SwitchFee from "./pages/components/managefee/SwitchFee";
import ViewStudentFee from "./pages/components/managefee/ViewStudentFee";
import SwitchSchoolSettings from "./pages/components/manageschool/SwitchSchoolSettings";
import ManageMessage from "./pages/components/managemessage";
import StudentParentList from "./pages/components/manageparent/StudentParentList";
import ViewEditStudentDetails from "./pages/components/manageparent/ViewEditStudentDetails";
import SwitchTransportation from "./pages/components/managetransportation/SwitchTransportation";
import HelpPage from "./pages/help/HelpPage";
import SwitchTabs from "./pages/components/instructorAttendance/SwitchTabs";
import InstructorReportStatus from "./pages/components/instructorAttendance/InstructorReportStatus";
import AdminLiveTracking from "./pages/Live tracking/SwitchTabs";
import SwitchClassAnnouncements from "./pages/components/managemessage/SwitchClassAnnouncements";
import SwitchWhatsApp from "./pages/components/managewhatsapp/SwitchWhatsApp";
import FunPage from "./pages/Is-kool-Junior/FunPage";

import SwitchSchedule from "./pages/components/manageschedule/SwitchSchedule";
import ManageAlarm from "./pages/components/managealarm/ManageAlarm";
import SwitchExpense from "./pages/components/manageexpenses/SwitchExpense";
import SwitchPayroll from "./pages/components/managepayroll/SwitchPayroll";
import SwitchCertBuilder from "./pages/components/manageform/SwitchCertBuilder";
import Iskool360Dashboard from "./pages/components/dashboard360/Iskool360Dashboard";
import SwitchTrip from "./pages/components/managetrip/SwitchTrip";
import SwitchStock from "./pages/components/managestock/SwitchStock";

import SwitchDailyActivity from "./pages/Is-kool-Junior/daily-activity/SwitchDailyActivity";

const url = "/dashboard";

const AdminMontessoriRoutes = () => {
  return (
    <Routes>
      <Route path="admin/menu" element={<AdminMontessoriMenu />} />
      <Route path="admin/menu/instructor" element={<InstructorPage />} />
      <Route path="admin/menu/support-staff" element={<SupportStaffPage />} />
      <Route path="admin/menu/instructor/profile/:id" element={<SwitchInstructor />} />
      <Route path="admin/menu/admission" element={<SwitchAdmission />} />
      <Route path="admin/menu/admission/:id" element={<AdmissionProfile />} />
      <Route path="admin/menu/admission/view/:id" element={<ViewAdmission />} />
      <Route path="admin/menu/student" element={<ManageStudentMain />} />
      <Route path="admin/menu/student/profile/:id" element={<SwitchStudent />} />
      <Route path="admin/menu/class" element={<ClassMain />} />
      <Route path="admin/menu/class/profile/:id" element={<SwitchClass />} />
      <Route path="admin/menu/homework" element={<HomeWork />} />
      <Route path="admin/menu/diary" element={<DiaryBoard role="admin" mode="junior" />} />
      <Route path="admin/menu/course-board" element={<AdminCourseBoardMain />} />
      <Route path="admin/menu/course-board/class/:classId" element={<AdminCourseBoardView />} />
      <Route path="admin/menu/fee/:tab" element={<SwitchFee />} />
      <Route path="admin/menu/class/:id/student/:id" element={<ViewStudentFee />} />
      <Route path="admin/menu/fee/template/:id" element={<AddEditFeeTemplate />} />
      <Route path="admin/menu/attendance" element={<SwitchMontessoriAttendance />} />
      <Route path="admin/menu/parent" element={<StudentParentList />} />
      <Route path="admin/menu/parent/:id" element={<ViewEditStudentDetails />} />
      <Route path="admin/menu/class-announcements" element={<SwitchClassAnnouncements />} />
      <Route path="admin/menu/whatsapp" element={<SwitchWhatsApp />} />
      <Route path="admin/menu/whatsapp/:tab" element={<SwitchWhatsApp />} />
      <Route path="admin/menu/instructor-attendance" element={<SwitchTabs />} />
      <Route path="admin/menu/instructor-attendance/report-status" element={<InstructorReportStatus />} />
      <Route path="admin/menu/schedule/" element={<SwitchSchedule />} />
      <Route path="admin/menu/alarm" element={<ManageAlarm />} />
      <Route path="admin/menu/message" element={<ManageMessage />} />
      <Route path="admin/menu/transportation/" element={<SwitchTransportation />} />
      <Route path="admin/menu/live-tracking/" element={<AdminLiveTracking />} />
      <Route path="admin/menu/fun/" element={<FunPage />} />
      <Route path="admin/menu/montessori-report/" element={<AdminSwitchMontessoriCard />} />
      <Route path="admin/menu/montessori-report/template/:id" element={<AdminMontessoriViewTemplate />} />
      <Route path="admin/menu/montessori-student/:id/template/:id" element={<AdminMontessoriAddEditScore />} />
      <Route path="admin/menu/montessori-student/:id/template/:id/report/:id/" element={<AdminMontessoriViewEditCard />} />
      <Route path="admin/menu/expenses" element={<SwitchExpense />} />
      <Route path="admin/menu/payroll" element={<SwitchPayroll />} />
      <Route path="admin/menu/consent-form/:tab" element={<SwitchTrip basePath="/dashboard/admin/menu/consent-form" />} />
      <Route path="admin/menu/stock" element={<SwitchStock />} />
      <Route path="admin/menu/certificate-builder" element={<SwitchCertBuilder />} />
      <Route path="admin/menu/school-settings" element={<SwitchSchoolSettings />} />
      <Route path="admin/help" element={<HelpPage />} />
      <Route path="admin/menu/montessori-template-history/:id" element={<AdminMontessoriViewHistory />} />
      <Route path="admin/profile" element={<Index />} />
      <Route path="admin/home" element={<Iskool360Dashboard />} />
      <Route path="admin/menu/daily-activity" element={<SwitchDailyActivity />} />
      <Route index element={<Navigate to={`${url}/admin/home`} replace />} />
    </Routes>
  );
};

export default AdminMontessoriRoutes;
